import React from 'react';
import ReactDOM from 'react-dom';
import '@/assets/css/common.scss'
import * as serviceWorker from './serviceWorker';
import Route from '@/routers/index'
import { Provider } from 'react-redux'
import { AppContainer} from 'react-hot-loader'
import { PersistGate } from 'redux-persist/integration/react'
import store, {persistor} from './redux/index'


const render = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <AppContainer>
                <Component/>
            </AppContainer>
        </PersistGate>
    </Provider>,
    document.getElementById('root'));
};

render(Route);

if (module.hot) {
  module.hot.accept('./routers/', () => {
    render(Route);
  })
}


serviceWorker.unregister();
